export default "__VITE_ASSET__decbb89f__"